var HeavyBoots = function (quality) {
  return {
    slot: 'boots',
    type: 'heavy',
    quality: quality,
    armorClass: Math.round(7 + quality * 35),
  };
};
module.exports = HeavyBoots;
